import React, { useState, useEffect } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import DiagnosisReportGrid from './DiagnosisReportGrid'
import { renderers } from '../../../../components'
import { GSXService } from '../../../../services'
import { showErrorToast } from '../../../../state/toasts'
import { useDispatch } from 'react-redux'

const RunDiagnosisFormHTML = ({ handleSubmit, device_identifier }) => {
  const dispatch = useDispatch()
  const [suiteDetails, setSuiteDetails] = useState([])
  const [initiatingDiagnosis, setInitiatingDiagnosis] = useState(false)
  const [isDiagnosticsInitiated, setIsDiagnosticsInitiated] = useState(false)
  const [diagnostics, setDiagnostics] = useState([])
  const runDiagnosisSuiteChange = (e) => {
    // eslint-disable-next-line
    const { name, value } = e.target
    if(value==="Select Suit To Run"){
      return
    }

    const data = { suiteId: value, identifier: device_identifier }
    setInitiatingDiagnosis(true)
    // this.setState({ diagnosticsInitiateRequest: true });
    new GSXService()
      .run_diagnosis_suite(data)
      .then((response) => {
        setInitiatingDiagnosis(false)
        setIsDiagnosticsInitiated(true)
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Could not run Diagnostic Suite ',
            errors.response.data
          )
        )
      })
  }
  const getDiagnosisResults = (e) => {
    const data = { identifier: device_identifier }
    // this.setState({ lookUpRequestInProgress: true });
    new GSXService().diagnostics_lookup(data).then((response) => {
      setDiagnostics(response.diagnostics)
    })
  }
  useEffect(() => {
    const getDiagnosticSuites = () => {
      let data = { identifier: device_identifier }
      new GSXService()
        .diagnostic_suites(data)
        .then((response) => {
          setSuiteDetails(response.suiteDetails)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast(
              'Could not get Diagnostic Suites ',
              errors.response.data
            )
          )
        })
    }
    getDiagnosticSuites()
  }, [device_identifier, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            onChange={runDiagnosisSuiteChange}
            name="diagnosis_suite"
            label="Select Diagnosis Suite To Run"
          >
              {suiteDetails &&
                  <option key={"SelectSuitToRun"} value={"Select Suit To Run"}>
                   Select Suit To Run
                  </option>
              }
            {suiteDetails &&
              suiteDetails.map((suite) => {
                return (
                  <option key={suite.suiteId} value={suite.suiteId}>
                    {suite.suiteName}
                  </option>
                )
              })}
          </Field>
          <ReactBootstrap.Alert show={initiatingDiagnosis} variant={'info'}>
            Diagnostics Request Being Send.
          </ReactBootstrap.Alert>
          <ReactBootstrap.Alert
            show={isDiagnosticsInitiated}
            variant={'success'}
          >
            Diagnostics Initiated
          </ReactBootstrap.Alert>
          <ReactBootstrap.Col className="text-end">
            <ReactBootstrap.Button
              variant="link"
              className="btn text-dark btn-sm"
              type="button"
              onClick={getDiagnosisResults}
            >
              Get Diagnosis Results
            </ReactBootstrap.Button>
          </ReactBootstrap.Col>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <DiagnosisReportGrid diagnostics={diagnostics} />
    </form>
  )
}
export const RunDiagnosisForm = reduxForm({
  form: 'run-device-diagnosis-form',
})(RunDiagnosisFormHTML)
